import {GuestGroupApi} from '../api';
import {FetcherSettings} from '../api/apiClient';
import {GuestGroup} from '../utils';
import {GuestGroupPayload} from './types';

class GuestGroupService {
  private readonly guestGroupApi: GuestGroupApi;
  constructor() {
    this.guestGroupApi = new GuestGroupApi();
  }

  getGuestGroup(id: string, resolverSettings?: FetcherSettings): Promise<GuestGroup> {
    if (!id) {
      throw new Error('The guest-group id param is not found');
    }
    return this.guestGroupApi.getGuestGroup(id, resolverSettings);
  }

  patchGuestGroup(
    id: string,
    payload: GuestGroupPayload,
    resolverSettings?: FetcherSettings,
  ) {
    if (!id || !payload) {
      throw new Error('The guest group id or payload argument is not found');
    }
    return this.guestGroupApi.patchGuestGroup(id, payload, resolverSettings);
  }
}

export {GuestGroupService};
